import React, { useContext /*, useState*/ } from 'react';
import { StyleSheet, View } from 'react-native';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import PropTypes from 'prop-types';
import CdnImage from '../common/CdnImage';
// import CdnImageBackground from '../common/CdnImageBackground';
// import ComponentContainer from '../common/ComponentContainer';
import { H4 } from '../text';
import LayoutContext from '../../contexts/Layout';

const IconPlusHeading = ({
    backgroundColor,
    backgroundImage,
    enableImageOverlay = false,
    iconClass,
    iconImage,
    nodeTypeAlias = 'IconPlusHeading',
    textColor = '#000',
    title,
    width
}) => {
    const { layout } = useContext(LayoutContext);
    // const [imageDimensions, setImageDimensions] = useState();
    const iconImageSrc = iconImage?.cdnImagePath;
    // const backgroundImageSrc = backgroundImage?.cdnImagePath;

    return (
        <View style={Styles.wrapper} dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            {/* <CdnImageBackground
                enableOverlay={enableImageOverlay}
                imageDimensions={imageDimensions}
                setImageDimensions={setImageDimensions}
                style={{ backgroundColor, justifyContent: 'center' }}
                uri={backgroundImageSrc}
                width={width}
            > */}
            <View
                style={StyleSheet.flatten(Styles.container, { marginBottom: layout.styleGuide.spacer2, marginHorizontal: layout.styleGuide.spacer1 })}
                dataSet={{
                    spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2}`,
                    spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1}))`,
                    spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1}))`
                }}
            >
                {!!iconClass && !iconImageSrc && <FontAwesome6 name={iconClass} size={60} color={textColor} />}
                {!iconClass && iconImageSrc && <CdnImage uri={iconImageSrc} width={60} />}
                {!!title && (
                    <H4
                        style={{ color: textColor, paddingLeft: layout.styleGuide.spacer4 }}
                        text={title}
                        dataSet={{ spacerLeft: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}
                    />
                )}
            </View>
            {/* </CdnImageBackground> */}
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: 'transparent',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    wrapper: {
        alignContent: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    }
});

IconPlusHeading.propTypes = {
    title: PropTypes.string,
    iconClass: PropTypes.string,
    iconImage: PropTypes.shape({
        cdnImagePath: PropTypes.string.isRequired
    }),
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    backgroundImage: PropTypes.shape({
        cdnImagePath: PropTypes.string.isRequired
    }),
    enableImageOverlay: PropTypes.bool
};

export default IconPlusHeading;
